<template>
  <div class="home">
    <!-- 接收子组件通知切换页面 -->
    <NavBar @switch-view="switchView" @search="handleSearch" :current-view="currentView" />

    <div class="main-content">

      <!-- 首页内容 -->
      <div v-if="currentView === 'home'">
        <Banner />

        <section class="products">
          <div class="products-header">
            <h2>🔥 新品推荐</h2>
            <span class="more-text" @click="switchView('category')">
              查看更多
            </span>
          </div>

          <div class="grid">
            <ProductCard
              v-for="(p, i) in products"
              :key="i"
              :product="p"
              @click="goProductDetail(p)"
            />
          </div>
        </section>
      </div>

      <!-- 源码分类 -->
      <div v-if="currentView === 'category'" class="category-container">
        <CategoryPage :keyword="categoryKeyword" :search-token="searchToken" @open-detail="goProductDetail"/>
      </div>

      <!-- 关于我们 -->
      <div v-if="currentView === 'about'" class="about-container">
        <AboutPage />
      </div>

      <!-- 详情页 -->
      <div v-if="currentView === 'detail'" class="detail-container">
        <ProductDetail
          :product="selectedProduct"
          :detail-token="detailToken"
          :clickView="clickView"
          @back-home="currentView='home'"
          @back-category="currentView='category'"
        />
      </div>

    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Banner from '@/components/Banner.vue'
import ProductCard from '@/components/ProductCard.vue'
import CategoryPage from '@/components/CategoryPage.vue'
import AboutPage from '@/components/AboutPage.vue'
import ProductDetail from '@/components/ProductDetail.vue'
import { BASE_URL } from '@/config/index.js'

export default {
  name: 'Home',
  components: { NavBar, Banner, ProductCard, CategoryPage, AboutPage, ProductDetail },

  data() {
    return {
      products: [],
      currentView: 'home',   // 默认显示首页
      searchToken: 0,
      detailToken: 0,
      categoryKeyword: '',   // 要传给 CategoryPage
      selectedProduct: '',    // 要传给 ProductDetail
      clickView: 'home'
    }
  },

  created() {
    document.title = '首页-源码大全'
    this.loadProducts()
  },

  methods: {
    /** 切换显示内容 */
    switchView(view) {
      this.searchToken = Date.now()
      this.currentView = view
      this.clickView = view

      switch(view) {
        case 'home':
          document.title = '首页-源码大全'
          break
        case 'category':
          document.title = '源码分类-源码大全'
          break
        case 'about':
          document.title = '关于我们-源码大全'
          break
        default:
          document.title = '源码大全'
      }
    },

    handleSearch(payload) {
      this.categoryKeyword = payload.keyword      // ① 保存搜索词
      this.searchToken = payload.token
      this.currentView = 'category'       // ② 切换到分类页
      this.clickView = 'category'       // ② 切换到分类页
    },

    goProductDetail(product) {
      this.selectedProduct = product
      this.detailToken = Date.now()
      this.currentView = 'detail'
    },

    loadProducts() {
      this.$http.get('/system/products/getList?pageNum=1&pageSize=1000&isRecommended=1')
        .then(res => {
          if (res.code === 200) {
            res.rows.forEach(item => {
              item.coverImage = BASE_URL + item.coverImage
            })
            this.products = res.rows
          }else {
            console.error('加载产品状态非200', res)
            this.$message({
              message: res.msg || '加载失败',
              type: 'warning',
              duration: 3000 // 显示时长，单位毫秒
            })
          }
        })
        .catch(err => {
          console.error('加载产品失败', err)
        })
    },
  }
}
</script>


<style scoped>
.home {
  min-height: 100vh;
}

.main-content {
  width: 100%;
}

/* 首页产品区域样式 */
.products {
  padding: 20px 10%;
  max-width: 100%;
}

.products h2 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  color: #333;
}

.products-header {
  position: relative;
  margin-bottom: 30px;
  text-align: center; /* 标题居中 */
}

.products-header h2 {
  font-size: 28px;
  margin: 0;
}

/* 右侧查看更多文字 */
.more-text {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
}

.more-text:hover {
  text-decoration: underline;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  justify-items: center;
}

/* 分类页面容器 */
.category-container,
.about-container {
  padding: 0 10%;
  width: 100%;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .products,
  .category-container,
  .about-container {
    padding: 40px 5%;
  }
}

@media (max-width: 768px) {
  .products,
  .category-container,
  .about-container {
    padding: 30px 3%;
  }

  .grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .products h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue